
import React, { useEffect } from "react";
import RequestImage from "../assets/Images/request_submitted.png";
import Footer from "../components/Footer";
import { Stack, Typography, Container, Button } from "@mui/material";
import Navbar from "../components/Navbar";
import ShowRouting from "../components/ShowRouting";
import _ from "lodash";
import { Link, useNavigate } from "react-router-dom";
const BookingConfirmed = () => {
    const navigate = useNavigate();
    useEffect(() => {
        let user = {};
        user = JSON.parse(localStorage.getItem("user-info"));
        if (_.isEmpty(user)) {
            navigate("/login");
        }
    }, []);
    return (
        <>
            <Navbar />
            <Container >
                <ShowRouting route="Home / Create Request" />
                <Stack spacing={10}>
                    <Stack className="d-flex" spacing={7}>
                        <Typography
                            variant="h5"
                            gutterBottom
                            component="div"
                            className="t-a-c"
                        >
                            Your Booking is Confirmed.
                        </Typography>
                        <Typography
                            variant="body2"
                            gutterBottom
                            component="div"
                            className="t-a-c"
                        >
                            Your booking created successfully. Our Expert will be soon be
                            <br />
                            at your service. Thank you.
                        </Typography>
                    </Stack>

                    <Stack className="t-a-c mb-10">
                        <div>
                            <Link to="/my-bookings/booking-details">
                                <Button
                                    variant="contained"


                                >
                                    View Booking Details
                                </Button>
                            </Link>
                        </div>
                    </Stack>
                </Stack>
            </Container>
            <Footer />
        </>
    )
}

export default BookingConfirmed